/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type TherapistDashboard, therapistDashboardApi } from '../api/therapist-dashboard.js';

/**
 * The therapist's own dashboard. Polls every 60s and refetches on focus so the
 * caseload metrics stay close to real-time without a socket.
 */
export function useTherapistDashboard(): UseQueryResult<TherapistDashboard> {
  return useQuery({
    queryKey: ['therapist', 'dashboard'],
    queryFn: () => therapistDashboardApi.overview(),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
